import React from "react";
import ShimmerLoader from "../../../components/ShimmerLoader";

const Pagination = ({ nPages, currentPage, setCurrentPage, loading,onPageChange }) => {
  const pageNumbers = [...Array(nPages + 1).keys()].slice(1);

  const handlePageChange = (newPage) => {
    if (newPage !== currentPage && !loading) {
      setCurrentPage(newPage);
      onPageChange(newPage);
    }
  }
  const nextPage = () => {
    if (currentPage !== nPages) handlePageChange(currentPage + 1);
  };
  const prevPage = () => {
    if (currentPage !== 1) handlePageChange(currentPage - 1);
  };
  if (nPages <= 0) {
    return null;
  }
  return (
    <nav>
      <div className="pagination">
        {loading ? <ShimmerLoader width='7rem' height='2rem' /> : <>
          <div className="page-item1">
            <button onClick={prevPage} disabled={currentPage === 1}>
                <img 
                  src={currentPage!=1?"/chevron-Left.svg":"/chevron-left-gray.svg"} 
                  alt={currentPage!=1?"chevron-Left.svg":"chevron-left-gray.svg"}
                />             
            </button>
          </div>
          {pageNumbers <= 2 ? (
            pageNumbers.map((pgNumber) => (
              <button
                onClick={() => handlePageChange(pgNumber)}
                className={`page-item ${currentPage == pgNumber ? "active" : ""
                  } `}
                key={pgNumber}
                disabled={currentPage==pageNumbers}
              >
                {pgNumber}
              </button>
            ))
          ) : (
            <>
              {currentPage !== pageNumbers[0] && (
                <button
                  onClick={() => handlePageChange(pageNumbers[0])}
                  className={`page-item ${currentPage === pageNumbers[0] ? "active" : ""
                    }`}
                  key={pageNumbers[0]}
                >
                  {pageNumbers[0]}
                </button>
              )}
              {currentPage > 2 && <span className="dots">...</span>}
              {pageNumbers
                .filter(
                  (pgNumber) =>
                    pgNumber > currentPage - 1 && pgNumber < currentPage + 2
                )
                .map((pgNumber) => (
                  <button
                    onClick={() => handlePageChange(pgNumber)}
                    className={`page-item ${currentPage === pgNumber ? "active" : ""
                      }`}
                    key={pgNumber}
                  >
                    {pgNumber}
                  </button>
                ))}
              {currentPage < pageNumbers.length - 2 && (
                <span className="dots">...</span>
              )}
              {currentPage <= pageNumbers.length - 2 && (
                <button
                  onClick={() =>
                    handlePageChange(pageNumbers[pageNumbers.length - 1])
                  }
                  className={`page-item ${currentPage === pageNumbers[pageNumbers.length - 1]
                      ? "active"
                      : ""
                    }`}
                  key={pageNumbers[pageNumbers.length - 1]}
                >
                  {pageNumbers[pageNumbers.length - 1]}
                </button>
              )}
            </>
          )}
          <div className="page-item2">
            <button
              onClick={nextPage}
              disabled={currentPage === pageNumbers.length||pageNumbers.length==1}
            >
                <img 
                  src={currentPage === pageNumbers.length? "/chevron-right-gray.svg":"/Chevron-Right.svg"} 
                  alt={currentPage===pageNumbers.lenght?"/chevron-right-gray.svg":"/Chevron-Right.svg"} 
                />
            </button>
          </div>
        </>}

      </div>
    </nav>
  );
};

export default Pagination;
